// Base API URL
// export const API_URL = "http://localhost:8000/api/v1";
export const API_URL = "https://api.trunorthwest.net/api/v1";

// Auth endpoints
export const AUTH_ENDPOINTS = {
  LOGIN: "/auth/login",
  LOGOUT: "/auth/logout",
  REGISTER: "/auth/register",
  LOGOUT_ALL: "/auth/logout-all",
  REQUEST_OTP: "/auth/request-otp",
  REVOKE_TOKEN: "/auth/revoke-token",
  VERIFY_EMAIL: "/auth/verify-email",
  REFRESH_TOKEN: "/auth/refresh-token",
  RESET_PASSWORD: "/auth/reset-password",
  FORGOT_PASSWORD: "/auth/forgot-password",
  ME: "/auth/me",
};

// User endpoints
export const USER_ENDPOINTS = {
  CREATE: "/users",
  GET_ALL: "/users",
  UPDATE: (id: number) => `/users/${id}`,
  DELETE: (id: number) => `/users/${id}`,
  GET_BY_ID: (id: number) => `/users/${id}`,
  UPDATE_PASSWORD: (id: number) => `/users/${id}/password`,
  GET_BY_ROLE: "/users-by-role",
  GET_ASSIGNABLE_ROLES: "/users/assignable-roles",
};

// Exam Sessions endpoints
export const EXAM_SESSIONS_ENDPOINTS = {
  CREATE: "/exam-sessions",
  GET_ALL: "/exam-sessions",
  GET_CURRENT: "/exam-sessions/current",
  UPDATE: (id: number) => `/exam-sessions/${id}`,
  DELETE: (id: number) => `/exam-sessions/${id}`,
  GET_BY_ID: (id: number) => `/exam-sessions/${id}`,
};

// Exam Types endpoints
export const EXAM_TYPES_ENDPOINTS = {
  CREATE: "/exam-types",
  GET_ALL: "/exam-types",
  UPDATE: (id: number) => `/exam-types/${id}`,
  DELETE: (id: number) => `/exam-types/${id}`,
  GET_BY_ID: (id: number) => `/exam-types/${id}`,
};

// Exam Types with details endpoints
export const EXAM_TYPES_WITH_DETAILS_ENDPOINTS = {
  GET_ALL_WITH_DETAILS: "/exam-types-with-details",
};

// Exam Categories endpoints
export const EXAM_CATEGORIES_ENDPOINTS = {
  CREATE: "/exam-categories",
  GET_ALL: "/exam-categories",
  UPDATE: (id: number) => `/exam-categories/${id}`,
  DELETE: (id: number) => `/exam-categories/${id}`,
  GET_BY_ID: (id: number) => `/exam-categories/${id}`,
};

// Subjects endpoints
export const SUBJECTS_ENDPOINTS = {
  CREATE: "/subjects",
  GET_ALL: "/subjects",
  UPDATE: (id: number) => `/subjects/${id}`,
  DELETE: (id: number) => `/subjects/${id}`,
  GET_BY_ID: (id: number) => `/subjects/${id}`,
  GET_BY_CATEGORY: (categoryId: number) => `/subjects/category/${categoryId}`,
  GET_BY_EXAM_TYPE: (examTypeId: number) => `/subjects/exam-type/${examTypeId}`,
  BATCH_CREATE: "/subjects/batch",
  BATCH_UPDATE: "/subjects/batch",
  BATCH_DELETE: "/subjects/batch",
};

// Regions endpoints
export const REGIONS_ENDPOINTS = {
  GET_ALL: "/regions",
};

// Divisions endpoints
export const DIVISIONS_ENDPOINTS = {
  GET_ALL: "/divisions",
  GET_BY_REGION: (regionId: number) => `/divisions?region_id=${regionId}`,
};

// Schools endpoints
export const SCHOOLS_ENDPOINTS = {
  CREATE: "/schools",
  GET_ALL: "/schools",
  GET_OWN_SCHOOL: "/schools/own",
  UPDATE: (id: number) => `/schools/${id}`,
  DELETE: (id: number) => `/schools/${id}`,
  GET_BY_ID: (id: number) => `/schools/${id}`,
};

// Exam Registration endpoints
export const EXAM_REG_ENDPOINTS = {
  CREATE: "/exam-registrations",
  GET_ALL: "/exam-registrations",
  UPDATE: (id: string) => `/exam-registrations/${id}`,
  DELETE: (id: number) => `/exam-registrations/${id}`,
  BATCH_UPDATE: "/exam-registrations",
  BATCH_DELETE: "/exam-registrations",
  GET_OWN_SCHOOL_REG: "/exam-registrations/school/own",
  GET_BY_ID: (id: string) => `/exam-registrations/${id}`,
};

// Subject Registration endpoints
export const SUBJECTS_REG_ENDPOINTS = {
  CREATE: "/subject-registrations",
  GET_ALL: `/subject-registrations`,
  BATCH_UPDATE: "/subject-registrations",
  CREATE_BATCH: "/subject-registrations/batch",
  GET_OWN_SCHOOL: `/subject-registrations/school`,
  GET: (id: number) => `/subject-registrations/${id}`,
  UPDATE: (id: number) => `/subject-registrations/${id}`,
  DELETE: (id: number) => `/subject-registrations/${id}`,
};

// Payment endpoints
export const PAYMENT_ENDPOINTS = {
  CREATE: "/payments",
  GET_ALL: "/payments",
  UPDATE: (id: number) => `/payments/${id}`,
  GET_BY_ID: (id: number) => `/payments/${id}`,
  ADMIN_GET_EXAM_PAYMENTS: "/payments/admin/exam-payments",
  ADMIN_UPDATE_STATUS: "/payments/admin/update-status",
};

// Reports endpoints
export const REPORTS_ENDPOINTS = {
  COMBINED: "/reports/combined",
  COMBINED_EXPORT: "/reports/combined/export",
  SCHOOLS_REPORTS: "reports/schools",
  SCHOOL_EXAM_REPORTS: "/reports/school-exam-reports",
  SCHOOL_EXAM_TYPES: (schoolId: number) =>
    `/reports/school-exam-types/${schoolId}`,
  SUBJECT_STUDENTS: (subjectId: number) =>
    `/reports/subject-students/${subjectId}`,
  SUBJECT_EXAM_TYPE: (subjectId: number) =>
    `/reports/subject-exam-type/${subjectId}`,
  SCHOOLS_BY_SUBJECTS: "/reports/schools-by-subjects",
};

// Exam Receipts endpoints
export const EXAM_RECEIPTS_ENDPOINTS = {
  GET_ALL: "/reports/exam-receipts",
};

// Dashboard endpoints
export const DASHBOARD_ENDPOINTS = {
  ANALYTICS: "/dashboard/analytics",
  SCHOOL_ANALYTICS: "/dashboard/school-analytics",
};

// Exam Registration Forms endpoints
export const EXAM_REGISTRATION_FORMS_ENDPOINTS = {
  CREATE: "/exam-registration-forms",
  GET_ALL: "/exam-registration-forms",
  UPDATE: (id: number) => `/exam-registration-forms/${id}`,
  DELETE: (id: number) => `/exam-registration-forms/${id}`,
  GET_BY_ID: (id: number) => `/exam-registration-forms/${id}`,
  DOWNLOAD: (id: number) => `/exam-registration-forms/${id}/download`,
  PREVIEW: (id: number) => `/exam-registration-forms/${id}/preview`,
};

// Past Exam Questions endpoints
export const PAST_EXAM_QUESTIONS_ENDPOINTS = {
  CREATE: "/past-exam-questions",
  GET_ALL: "/past-exam-questions",
  UPDATE: (id: number) => `/past-exam-questions/${id}`,
  DELETE: (id: number) => `/past-exam-questions/${id}`,
  GET_BY_ID: (id: number) => `/past-exam-questions/${id}`,
  DOWNLOAD: (id: number) => `/past-exam-questions/${id}/download`,
  PREVIEW: (id: number) => `/past-exam-questions/${id}/preview`,
};

// Schemes of Work endpoints
export const SCHEMES_OF_WORK_ENDPOINTS = {
  CREATE: "/schemes-of-work",
  GET_ALL: "/schemes-of-work",
  UPDATE: (id: number) => `/schemes-of-work/${id}`,
  DELETE: (id: number) => `/schemes-of-work/${id}`,
  GET_BY_ID: (id: number) => `/schemes-of-work/${id}`,
  DOWNLOAD: (id: number) => `/schemes-of-work/${id}/download`,
  PREVIEW: (id: number) => `/schemes-of-work/${id}/preview`,
};

// Landing Page endpoints
export const LANDING_STATS_ENDPOINTS = {
  CREATE: "/landing-stats",
  GET_ALL: "/landing-stats",
  UPDATE: (id: number) => `/landing-stats/${id}`,
  DELETE: (id: number) => `/landing-stats/${id}`,
  GET_BY_ID: (id: number) => `/landing-stats/${id}`,
  PUBLIC: "/landing/stats",
};

export const LANDING_SERVICES_ENDPOINTS = {
  CREATE: "/landing-services",
  GET_ALL: "/landing-services",
  UPDATE: (id: number) => `/landing-services/${id}`,
  DELETE: (id: number) => `/landing-services/${id}`,
  GET_BY_ID: (id: number) => `/landing-services/${id}`,
  PUBLIC: "/landing/services",
};

export const TRAINING_PROGRAMS_ENDPOINTS = {
  CREATE: "/training-programs",
  GET_ALL: "/training-programs",
  UPDATE: (id: number) => `/training-programs/${id}`,
  DELETE: (id: number) => `/training-programs/${id}`,
  GET_BY_ID: (id: number) => `/training-programs/${id}`,
  PUBLIC: "/landing/training-programs",
};

export const TESTIMONIALS_ENDPOINTS = {
  CREATE: "/testimonials",
  GET_ALL: "/testimonials",
  UPDATE: (id: number) => `/testimonials/${id}`,
  DELETE: (id: number) => `/testimonials/${id}`,
  GET_BY_ID: (id: number) => `/testimonials/${id}`,
  PUBLIC: "/landing/testimonials",
};

export const DEPARTMENTS_ENDPOINTS = {
  CREATE: "/departments",
  GET_ALL: "/departments",
  UPDATE: (id: number) => `/departments/${id}`,
  DELETE: (id: number) => `/departments/${id}`,
  GET_BY_ID: (id: number) => `/departments/${id}`,
  PUBLIC: "/landing/departments",
};

export const ANNOUNCEMENTS_ENDPOINTS = {
  CREATE: "/announcements",
  GET_ALL: "/announcements",
  UPDATE: (id: number) => `/announcements/${id}`,
  DELETE: (id: number) => `/announcements/${id}`,
  GET_BY_ID: (id: number) => `/announcements/${id}`,
  PUBLIC: "/landing/announcements",
};

export const LANDING_PAGE_SETTINGS_ENDPOINTS = {
  GET_ALL: "/landing-page-settings",
  CREATE: "/landing-page-settings",
  UPDATE: (key: string) => `/landing-page-settings/${key}`,
  BULK_UPDATE: "/landing-page-settings/bulk-update",
  PUBLIC: "/landing/settings",
};

export const HERO_SECTIONS_ENDPOINTS = {
  CREATE: "/hero-sections",
  GET_ALL: "/hero-sections",
  UPDATE: (id: number) => `/hero-sections/${id}`,
  DELETE: (id: number) => `/hero-sections/${id}`,
  GET_BY_ID: (id: number) => `/hero-sections/${id}`,
  PUBLIC: "/landing/hero",
};

export const FOOTER_CONTACTS_ENDPOINTS = {
  CREATE: "/footer-contacts",
  GET_ALL: "/footer-contacts",
  UPDATE: (id: number) => `/footer-contacts/${id}`,
  DELETE: (id: number) => `/footer-contacts/${id}`,
  GET_BY_ID: (id: number) => `/footer-contacts/${id}`,
  PUBLIC: "/landing/footer-contacts",
};

export const FOOTER_SECTIONS_ENDPOINTS = {
  CREATE: "/footer-sections",
  GET_ALL: "/footer-sections",
  UPDATE: (id: number) => `/footer-sections/${id}`,
  DELETE: (id: number) => `/footer-sections/${id}`,
  GET_BY_ID: (id: number) => `/footer-sections/${id}`,
  PUBLIC: "/landing/footer-sections",
};

// Storage keys
export const STORAGE_KEYS = {
  ACCESS_TOKEN: "@auth_token",
};

// Request timeout in milliseconds
export const REQUEST_TIMEOUT = 30000;

// Headers with dynamic language
export const getCommonHeaders = async () => {
  const language = localStorage.getItem("lang");

  return {
    "Content-Type": "application/json",
    Accept: "application/json",
    "Accept-Language": language || "en",
  };
};
